import { combineReducers } from '@reduxjs/toolkit';

import bookingReducer from './slices/booking';
import workflowReducer from './slices/workflow';

const rootReducer = combineReducers({
  booking: bookingReducer,
  workflow: workflowReducer,
});

export default rootReducer;
